import { render, staticRenderFns } from "./FurnitureSelectorBody.vue?vue&type=template&id=ffce1ec6&scoped=true&"
import script from "./FurnitureSelectorBody.vue?vue&type=script&lang=js&"
export * from "./FurnitureSelectorBody.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureSelectorBody.vue?vue&type=style&index=0&id=ffce1ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce1ec6",
  null
  
)

export default component.exports